import { render, staticRenderFns } from "./GiftCards.vue?vue&type=template&id=ff8cca00"
import script from "./GiftCards.vue?vue&type=script&lang=js"
export * from "./GiftCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports